import tinycolor from 'tinycolor2'

export default function toRgbString(color: string): null | string {
  if (!color)
    return null

  return tinycolor(color).toRgbString()
}
